import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { PermissionService } from '@abp/ng.core';

import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ButtonModule } from 'primeng/button';

import { filter } from 'rxjs/operators';
import { MenuItems } from '../menu';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, PanelMenuModule, ButtonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class AppSidebarComponent implements OnInit {
  items: MenuItem[] = [];
  isCollapsed = false;
  envLabel = environment['label'];
  @Output() collapsedChange = new EventEmitter<boolean>();

  constructor(
    private readonly permissionService: PermissionService,
    private readonly router: Router
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateActiveStates();
    });
  }

  private hasRequiredPolicy(item: MenuItem): boolean {
    if (item['requiredPolicy']) {
      const policy = item['requiredPolicy'];
      const hasPermission = this.permissionService.getGrantedPolicy(policy);
      return hasPermission;
    }
    return true;
  }

  private filterMenuItems(items: MenuItem[]): MenuItem[] {
    if (!items) return [];

    return items
      .filter((item) => this.hasRequiredPolicy(item))
      .map((item) => ({
        ...item,
        items: this.filterMenuItems(item.items || []),
        expanded: this.shouldExpandMenuItem(item),
        styleClass: this.hasActiveChild(item) ? 'parent-active' : '',
        rule: item.label === 'Home' ? 'exact' : 'subset',
      }));
  }

  ngOnInit() {
    this.items = this.filterMenuItems(MenuItems);
  }

  private hasActiveChild(item: MenuItem): boolean {
    if (!item.items) {
      return false;
    }
    return item.items.some(
      (subItem) =>
        subItem['route'] &&
        this.router.isActive(subItem['route'][0], {
          paths: 'subset',
          queryParams: 'ignored',
          fragment: 'ignored',
          matrixParams: 'ignored',
        })
    );
  }

  private shouldExpandMenuItem(item: MenuItem): boolean {
    if (!item.items) {
      return false;
    }
    return this.hasActiveChild(item);
  }

  private updateActiveStates() {
    this.items.forEach((item) => {
      if (item.items) {
        item.expanded = this.shouldExpandMenuItem(item);
        item.styleClass = this.hasActiveChild(item) ? 'parent-active' : '';
      }
    });
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }
}
